import { render } from "./BusinessSetUp.vue?vue&type=template&id=13264d9f"
import script from "./BusinessSetUp.vue?vue&type=script&lang=js"
export * from "./BusinessSetUp.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agent\\_work\\82\\s\\SimpleSums\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__